import React from "react";
import { IconProps } from ".";

const SearchIcon: React.FC<IconProps> = ({
  size = "16",
  color = "currentColor",
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M13.4766 11.9716H12.6866L12.4066 11.7016C13.6066 10.3016 14.2266 8.39156 13.8866 6.36156C13.4166 3.58156 11.0966 1.36156 8.29658 1.02156C4.06658 0.501558 0.506578 4.06156 1.02658 8.29156C1.36658 11.0916 3.58658 13.4116 6.36658 13.8816C8.39658 14.2216 10.3066 13.6016 11.7066 12.4016L11.9766 12.6816V13.4716L16.2266 17.7216C16.6366 18.1316 17.3066 18.1316 17.7166 17.7216C18.1266 17.3116 18.1266 16.6416 17.7166 16.2316L13.4766 11.9716ZM7.47658 11.9716C4.98658 11.9716 2.97658 9.96156 2.97658 7.47156C2.97658 4.98156 4.98658 2.97156 7.47658 2.97156C9.96658 2.97156 11.9766 4.98156 11.9766 7.47156C11.9766 9.96156 9.96658 11.9716 7.47658 11.9716Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
